/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Paging from '../../component/Paging';
import request from '../../../utils/Request.utils';
import { ToastContainer, toast } from 'react-toastify';

const PaymentCompleteList = () => {
    const [refunds, setRefunds] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currPage, setCurrPage] = useState(1);
    const [totalCnt, setTotalCnt] = useState(0);
    const [loading, setLoading] = useState(true);
    // 검색
    const [status, setStatus] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [inputQuery, setInputQuery] = useState(''); // 입력 필드 상태

    // 상태
    const [payStatList, setPayStatList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('전체');

    const [searchStartDate, setSearchStartDate] = useState('');
    const [searchEndDate, setSearchEndDate] = useState('');

    const getPayStat = () => {
        let params = {};

        const successHandler = (response) => {
            if (response.messageCode === 200) {
                setPayStatList(response.data.data_list);
            } else {
                console.log('결제 상태정보를 불러올 수 없습니다.');
                toast.error('결제 상태정보를 불러올 수 없습니다.');
            }
        };
        const failHandler = (error) => {
            console.log(error);
        };

        ///admin/list
        request.get('/common/code/pay_stat', params, successHandler, failHandler);
    };

    const successHandler = useCallback((response) => {
        console.log('response :', response);
        if (response.messageCode === 200) {
            setRefunds(response.data.dataList);
            setTotalPages(response.data.tot_page);
            setTotalCnt(response.data.totalCnt);
            setLoading(false);
        } else {
            toast.error('결제 정보를 불러올 수 없습니다.');
            setLoading(false);
        }
    }, []);

    const errorHandler = useCallback((error) => {
        toast.error('데이터를 불러오는 중 오류가 발생했습니다.');
        setLoading(false);
    }, []);

    const fetchPayments = useCallback(() => {
        setLoading(true);
        const params = {
            curr_page: currPage,
            per_page: 10,
            sort_col: 'reg_dtm',
            sort_by: 'desc',
            refund_stat: status === '' ? '' : status,
            search_query: searchQuery,
            search_start_date: searchStartDate,
            search_end_date: searchEndDate,
        };
        request.get('/refund/admin/list', params, successHandler, errorHandler);
    }, [currPage, searchQuery, selectedStatus, searchStartDate, searchEndDate, successHandler, errorHandler, status]);

    useEffect(() => {
        fetchPayments();
    }, [fetchPayments, currPage]);

    useEffect(() => {
        getPayStat();
    }, []);

    const handlePageChange = (page) => {
        setCurrPage(page);
    };

    const handleSearch = () => {
        setSearchQuery(inputQuery);
    };

    const handleReset = () => {
        setInputQuery('');
        setSearchQuery('');
        setSearchStartDate('');
        setSearchEndDate('');
        setCurrPage(1);
        fetchPayments();
    };

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
    };

    const handleDateRangeClick = (rangeType) => {
        const today = new Date();
        let start = new Date();
        let end = new Date();

        switch (rangeType) {
            case 'today':
                // start and end are already set to today
                break;
            case 'yesterday':
                start.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                break;
            case 'week':
                start.setDate(today.getDate() - 7);
                break;
            case 'month':
                start.setDate(1);
                break;
            default:
                break;
        }

        setSearchStartDate(start.toISOString().split('T')[0]);
        setSearchEndDate(end.toISOString().split('T')[0]);
    };

    return (
        <main>
            <h2 className="adm_com_pg_tit">결제 환불 신청</h2>
            <div className="adm_com_pg_content">
                <div className="adm_com_board_list__top">
                    <div className="adm_com_date_select">
                        <div>
                            <button
                                className={`adm_com_btn ${status === '1' ? `black` : `gray`}`}
                                onClick={() => setStatus(status === '1' ? '' : '1')}
                            >
                                환불신청
                            </button>
                            <button
                                className={`adm_com_btn ${status === '2' ? `black` : `gray`}`}
                                onClick={() => setStatus(status === '2' ? '' : '2')}
                            >
                                환불불가
                            </button>
                            <button
                                className={`adm_com_btn ${status === '3' ? `black` : `gray`}`}
                                onClick={() => setStatus(status === '3' ? '' : '3')}
                            >
                                환불완료
                            </button>
                        </div>
                        <span className="divider"> </span>
                        <input
                            type="date"
                            className="adm_com_datepicker"
                            value={searchStartDate}
                            onChange={(e) => setSearchStartDate(e.target.value)}
                        />
                        <span className="divider"> ~ </span>
                        <input
                            type="date"
                            className="adm_com_datepicker"
                            value={searchEndDate}
                            onChange={(e) => setSearchEndDate(e.target.value)}
                        />

                        <button className="adm_com_btn blue" onClick={handleSearch}>
                            조회
                        </button>
                    </div>
                </div>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <table className="adm_com_board_list">
                        <colgroup>
                            <col width="7%" />
                            <col width="8%" />
                            <col width="8%" />
                            <col width="8%" />
                            <col width="20%" />
                            <col width="8%" />
                            <col width="8%" />
                            <col width="8%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>신청일</th>
                                <th>신청자</th>
                                <th>비고</th>
                                <th>관리자</th>
                                <th>광고 url</th>
                                <th>환불 요청 금액</th>
                                <th>상태</th>
                                <th>상세보기</th>
                            </tr>
                        </thead>
                        <tbody>
                            {refunds.map((refund, index) => (
                                <tr key={refund.pay_seq}>
                                    <td>{refund.refund_app_dtm}</td>
                                    <td>{refund.user_email}</td>
                                    <td>{refund.message}</td>
                                    <td>{refund.admin_seq === null ? '-' : ''}</td>
                                    <td>-</td>
                                    <td>{refund.refund_app_amt} 원</td>
                                    <td>{refund.refund_stat}</td>
                                    <td>
                                        <Link to={`/Refund/View/${refund.rd_seq}`} className="adm_com_btn line blue">
                                            상세
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <Paging currentPage={currPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>
            <ToastContainer />
        </main>
    );
};

export default PaymentCompleteList;
